"use strict";
// @ts-ignore
try {
    self['workbox:streams:7.0.0'] && _();
}
catch (e) { }
